import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  OrderInfo,
  OrderItemDTO,

  getOrderItemsByOrderId,

  orderItemInvoice,
  resetOrderItemListInfo,
  resetOrderListInfo,
  useOrderSlice,
} from "../../../redux/slice/order/OrderSlice";
import OptionsPopup, {
  OptionPopupObjectProps,
} from "../../common/OptionsPopup";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomTextField from "../../common/CustomTextField";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import {
  Add,
  AddCircleOutlineOutlined,
  Cancel,
  CheckCircleOutline,
  Delete,
  Edit,
  Inventory2Outlined,
  PersonOutlined,
  ReceiptLongOutlined,
  AccountBalanceWalletOutlined,
} from "@mui/icons-material";
import CustomCheckbox from "../../common/CustomCheckBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable } from "../../../redux/slice/authSlice";
import dayjs from "dayjs";
import { getProductItemHistory } from "../../../redux/slice/product/createProductSlice";
import { getProductItem } from "../../../service/ProductService";
import {
  getPracticeProductById,
  getPracticeProductByPracticeProductId,
  PracticeInfo,
} from "../../../redux/slice/practiceSlice";
import {
  MainErrorInfo,
  SingleAlertInfo,
  setMainErrorObj,
  setSingleAlertObj,
} from "../../../redux/slice/commonSlice";
import CustomCurrencyField from "../../common/CustomCurrencyField";
import Dropzone, { ExtendedFile } from "../../common/Dropzone";
import {
  calculateCommissionAmount,
  calculateCommissionRate,
  convertBase64,
  formatValue,
  fullName,
  getCodeTableDisplayLabel,
  hideElement,
  isV3CommissionType,
  priceFormatter,
  sortNames,
  toCommissionTypeRequestKey,
} from "../../../utils/Utility";
import {
  addInvoice,
  Attachment,
  getApplyInvDetailById,
  SaveInvoiceInfo,
  useInvoiceSlice,
} from "../../../redux/slice/invoice/InvoiceSlice";
import { COMMISSION_TYPE_CODETABLE, ORDER_AVAILABILITY, ORDER_STATUS, RESPONSE_CODES } from "../../../constants/applicationConstants";
import { useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import moment from "moment";
import { useNavigation } from "../../../hooks/useNavigation";
import CustomIconButton from "../../common/CustomIconButton";
import OVRCommissionPopup from "./OvrCommissionPopup";
import AddProductCommissionModal from "../agency/ProductCommissionPopup";
import {
  fetchProductsByUserRoleData,
  ProductInfo,
  useProductListReducer,
} from "../../../redux/slice/product/productListSlice";
import {
  addAgencyProductCommission,
  AgencyOption,
  clearAddAgencyProductCommissionStatus,
  CreateSearchAgency,
  editAgencyProductCommission,
  fetchActiveAgencyExecutives,
  fetchAssociateAgencyList,
  fetchProductCommissionsByAgencyId,
  getPracticeListByUserRoleInAgency,
  Option,
  ProductCommissionAgency,
  useAgencyReducer,
} from "../../../redux/slice/agency/AgencySlice";
import EditCommissionPopup from "./EditCommissionPopup";
import { orderItemClaim, claimInfo, addClaim, reimburseClaimInfo, addReimbursedClaim } from "../../../redux/slice/claim/ClaimSlice";
import ProductCommissionPopup from "../agency/ProductCommissionPopup";
import { Row } from "../agency/AgencyForm";
import { SectionHeader } from "../../ui/ContentSection";
import { useModalStyles } from "../../common/useModalStyles";

export interface OrderItemRow {
  select: JSX.Element;
  orderItemId: number;
  serialNumber: string;
  size: string;
  mfgInvoiceNumber?: string;
  tissueTrackingId: number;
  productReturnId: number;
  productReturnStatus?: string;
  claim: orderItemClaim;
  invoice: orderItemInvoice;
  extendedPrice: number;
  invoiceId: number;
  units: number;
  hasSKUPrice: boolean;
  orderItemPrice: number;//CS-1560 - Adding order item price directly from backend
}

interface billingForm {
  insuranceClaim: string;
  mfgInvoice: string;
  invoiceAmt: number;
  invoicedDate: any;
  invoiceDueDate: string;
  calculatedAmt: number;
  attachment: Attachment[];
  comments: string;
}

interface FormattedOrderItem {
  orderItemId: number;
}

const Billing = () => {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      insuranceClaim: "",
      mfgInvoice: "",
      invoicedDate: "",
      invoiceDueDate: "",
      comments: ""
    },
  });

  const { navigate } = useNavigation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {
    tokens: mTokens,
    isDark: isDarkModal,
    datepickerWrapSx,
    inputFieldSx,
    primaryBtnSx,
    cancelBtnSx,
  } = useModalStyles();
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden",
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };
  const dispatch = useAppDispatch();
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const location = useLocation();
  const [order, setOrder] = useState<OrderInfo>();
  const [checkedList, setCheckedList] = useState<number[]>([]);
  const [showOptionPopup, setShowOptionsPopup] =
    useState<OptionPopupObjectProps>({ message: "", show: false });
  const [orderInfo, setOrderInfo] = useState<OrderInfo | undefined>(
    location?.state?.selectedOrderBilling
  );
  const { orderItemsListInfo, editProductCommissionStatus } = useOrderSlice();
  //CS-1191 - Start
  const { applyInvDetail } = useInvoiceSlice();
  //CS-1191 - End
  const [submitAction, setSubmitAction] = useState<string>();
  const [productExtendedPrice, setProductExtendedPrice] = useState<number>(0);
  const [orderItemRow, setOrderItemRow] = useState<OrderItemRow[] | []>([]);
  const [totalExtendedPrice, setTotalExtendedPrice] = useState(0);
  const [statusCount, setStatusCount] = useState<{
    orderItemsCount: number;
    countToCheck: number;
  }>({
    orderItemsCount: 0,
    countToCheck: 0,
  });
  const [extendedPriceInfo, setExtendedPriceInfo] = useState("");
  const [invoiceNetdays, setInvoiceNetdays] = useState(0);
  const [invoiceDueDate, setInvoiceDueDate] = useState<string | undefined>(
    undefined
  );
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isNarrow = useMediaQuery(theme.breakpoints.down("md"));
  const [showOvrCommissionPopup, setShowOvrCommissionPopup] = useState(false);
  const [showEditCommissionPopup, setShowEditCommissionPopup] = useState(false);
  const [agencyData, setAgencyData] = useState<any>({});
  const [newOvrCommissionData, setNewOvrCommissionData] = useState<any>([]);
  const [newInvSpecificCommissionData, setNewInvSpecificCommissionData] =
    useState<any>([]);
  const [combinedCommissionData, setCombinedCommissionData] = useState<any[]>(
    []
  );
  const PRACTICE_ENTITY: string = "PRACTICE";
  const AGENCY_ENTITY: string = "AGENCY";
  const ACCOUNT_REPRESENTATIVE_ENTITY: string = "ACCOUNTREP";
  const [availableGrafts, setAvailableGrafts] = useState<number[] | null>(null);
  const [product, setProduct] = useState<any>('');
  const [open, setOpen] = useState(false);
  const [selectedAssociateType, setSelectedAssociateType] = useState<any>('');
  const [isCommTypeOverride, setIsCommTypeOverride] = useState(false);
  const [editCommission, setEditCommission] = useState(false);
  const [selectedCommission, setSelectedCommission] = useState<Row>({
    productCommissionId: 0,
    productId: [],
    productName: undefined,
    associateType: undefined,
    associateAgencyId: undefined,
    associatePracticeId: undefined,
    associateAccountRepId: undefined,
    commissionRate: undefined,
    commissionPayTerms: undefined,
    associateAgencyName: undefined,
    associatePracticeName: undefined,
    associateAccountRepName: undefined,
    associateAgencyCommission: undefined,
    effectiveDate: undefined,
    inactiveDate: undefined,
    rowIndex: 1
  });
  const { associateAgencyList, practiceByUserRoleAgencySlice, agencyExecutives, addAgencyProductCommissionStatus } = useAgencyReducer();
  const [selectedAgency, setSelectedAgency] = useState(0);

  //CS-1322 - Reseting the state first on page load
  useEffect(() => {
  return () => {
    dispatch(resetOrderItemListInfo());
    setOrderItemRow([]); 
    dispatch(fetchAssociateAgencyList());
    dispatch(fetchActiveAgencyExecutives({ getAgencyAdmins: true, isInactive: true }));
    dispatch(getPracticeListByUserRoleInAgency(true));
  };
}, [dispatch]);

//CS-1567 START
  function extractShippingCharge(method:any) {
    if (!method || typeof method !== "string") return null;

    // Look specifically for dollar amounts inside parentheses
    // e.g. ($30), ( $10.12 ), ($ 450)
    const regex = /\(\s*\$\s*([0-9]+(?:\.[0-9]+)?)\s*\)/;
    const match = method.match(regex);

    return match ? parseFloat(match[1]) : null;
}

  const resolveShippingCharge = (orderDetails?: OrderInfo | null) => {
    if (!orderDetails) return null;

    if (orderDetails.isOutsideOrder) {
      if (orderDetails.outsideOrderShippingPrice === null || orderDetails.outsideOrderShippingPrice === undefined) return null;
      const outsideShippingPrice = Number(orderDetails.outsideOrderShippingPrice);
      return Number.isFinite(outsideShippingPrice) ? outsideShippingPrice : null;
    }

    //CS-1766 - Updated to get the shipping method based on order status as requested shipping method is only available for placed orders
    const shippingMethod = orderDetails.orderStatus === ORDER_STATUS.PLACED ? orderDetails.requestedShippingMethod : orderDetails.actualShippingMethod;
    return extractShippingCharge(shippingMethod);
  };
//
  useEffect(() => {
    const orderDetails: OrderInfo = location?.state?.selectedOrderBilling;
    setOrderInfo(orderDetails);
    if (!orderDetails) {
      return;
    }
    const dateOfService = orderDetails.dateOfService;
    const orderDate = orderDetails.orderDate;

    const fetchProduct = async () => {
      try {
        const product = await getProductItem(orderDetails.productId);
        setProduct(product.data.data);
        const customConfig = product?.data?.data?.manufactureCustomConfig;
        const invoiceDueDate =
          customConfig?.invoice_due_date &&
          customConfig?.invoice_due_date === "date_of_service"
            ? dateOfService
            : customConfig?.invoice_due_date &&
              customConfig?.invoice_due_date === "order_date"
            ? orderDate
            : "";
        const invoiceNetdays =
          customConfig?.invoice_net_days && customConfig?.invoice_net_days > 0
            ? customConfig?.invoice_net_days
            : 30;
        setInvoiceNetdays(invoiceNetdays);
        setInvoiceDueDate(invoiceDueDate);
        // if (invoiceDueDate) { CS-612 commented to prevent default initialization
        //   setValue(
        //     "invoiceDueDate",
        //     dayjs(invoiceDueDate)
        //       .add(invoiceNetdays, "day")
        //       .format("MM/DD/YYYY")
        //   );
        // }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };
    fetchProduct();
    dispatch(
      getApplyInvDetailById({
        practiceId: orderDetails.practiceId,
        productId: orderDetails.productId,
      })
    );

    dispatch(getProductItemHistory({ productId: orderDetails.productId }));
    dispatch(getOrderItemsByOrderId(orderDetails.orderId));
    dispatch(getPracticeProductById(orderDetails.productId.toString())).then(
      (res) => {
        if (res.payload) {
          const productAgreementObject = res.payload;
          setProductExtendedPrice(productAgreementObject.extendedPrice);
        }
      }
    );
  }, []);
 
  useEffect(() => {
    dispatch(
      getApplyInvDetailById({
        practiceId: location?.state?.selectedOrderBilling.practiceId,
        productId: location?.state?.selectedOrderBilling.productId,
      })
    );
  }, [editProductCommissionStatus === "success", addAgencyProductCommissionStatus === "success"]);

  const parseSize = (size: string): number => {
    const sizeWithoutCm = size.replace("cm", "");
    const [length, width] = sizeWithoutCm.split("x").map(Number);
    return length * width;
  };

  const modifyClaimObject = (
    claim: orderItemClaim,
    size: string
  ): orderItemClaim => {
    return {
      ...claim,
      claimAmount: parseSize(size) * 122,
    };
  };

  const selectedOrderItems: { orderItemId: number }[] = useMemo(() => {
    const newSelectedOrderItems: { orderItemId: number }[] = checkedList?.map(
      (id) => ({
        orderItemId: id,
      })
    );
    return newSelectedOrderItems;
  }, [checkedList]);

  const onSubmit = async (data: any) => {
    if (submitAction === "markClaim") {
      if (orderInfo) {
        const claimDtoObject: claimInfo = {
          orderId: orderInfo?.orderId,
          productId: orderInfo?.productId,
          claimNumber: data.insuranceClaim,
          claimStatus: "SUBMITTED",
          submittedDate: dayjs(new Date()).format("MM/DD/YYYY"),
          orderItems: [],
        };
        // const response = await dispatch(addClaim(claimDtoObject));

        // if (response.payload && response.payload.data.message === "SUCCESS") {
        //   let alertMessage = "Mark Claim Submitted!";
        //   const alertObj: SingleAlertInfo = {
        //     message: alertMessage,
        //     alertType: "success",
        //   };
        //   dispatch(setSingleAlertObj(alertObj));
        // }
      }
    } else if (submitAction === "markInvoiced") {
      if (checkedList?.length > 0) {
        //CS-1213 - Start
        const commissionRequests = combinedCommissionData?.map(
          (item, index) => {
            const amount = getValues(`commissionAmt-${index}`);
            return {
              agencyId: item.agencyId,
              agencyType: toCommissionTypeRequestKey(allCodeTablesValuesMap, item.agencyType),
              productCommissionId: item.productCommissionId || null,
              expectedCommissionRate:
                item.commissionRate !== null ? item.commissionRate : null,
              expectedCommissionAmount: amount || 0, // fallback to 0 if empty
              commissionChangeForAllFutureInvoices:
                item.commissionChangeForAllFutureInvoices || false,
            };
          }
        );
        const hasMissingV3Rate = commissionRequests?.some(
          (data: any) =>
            isV3CommissionType(allCodeTablesValuesMap, data?.agencyType) && data?.expectedCommissionRate === null
        );

        //CS-1213 - End
        setShowOptionsPopup({
          message:
            data.calculatedAmt == data.invoiceAmt
              ? "Do you really want to record the invoice?"
              : "Calculated Amount and Invoice Amount are not equal. Do you still want to record the invoice?",
          show: true,
          variant: "confirm",
          buttons: [
            {
              name: "Confirm",
              color: "primary",
              onClick: () => submitMarkInvoiced(data),
            },
            { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
          ],
        });
      } else {
        let alertMessage = "Please select atleast one order item";
        const alertObj: SingleAlertInfo = {
          message: alertMessage,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(alertObj));
      }
    }
  };

  const submitMarkInvoiced = async (data: billingForm) => {
    if (orderInfo) {
      const product = await getProductItem(orderInfo.productId);
      const manufacturerId =
        product && product.data.data && product.data.data.manufacturerId;

      const formattedInvoiceDueDate = data.invoiceDueDate 
             ? dayjs(data.invoiceDueDate).format("MM/DD/YYYY")
             : dayjs(data.invoicedDate).add(invoiceNetdays, "day").format("MM/DD/YYYY");

      const commissionRequests = combinedCommissionData?.map((item, index) => {
        const amount = getValues(`commissionAmt-${index}`);
        return {
          agencyId: item.agencyId,
          agencyType: toCommissionTypeRequestKey(allCodeTablesValuesMap, item.agencyType),
          productCommissionId: item.productCommissionId || null,
          expectedCommissionRate:
            item.commissionRate !== null ? item.commissionRate : null, //CS-1213
          expectedCommissionAmount: amount || 0, // fallback to 0 if empty
          commissionChangeForAllFutureInvoices:
            item.commissionChangeForAllFutureInvoices || false,
        };
      });
      const invoiceDtoObject: any = {
        //SaveInvoiceInfo
        orderId: orderInfo?.orderId,
        manufacturerId: manufacturerId,
        mfgInvoiceNumber: data.mfgInvoice,
        mfgInvoiceDate: dayjs(data?.invoicedDate).format("MM/DD/YYYY"), // CS-1588 - Updating the code to set the invoice selected date as mfgInvoiceDate
        invoiceDueDate: formattedInvoiceDueDate,
        calculatedAmount: data.calculatedAmt,
        invoiceAmount: Number(data.invoiceAmt),
        shippingCharges: shippingCharge,
        lateFee: lateFee,
        orderItems: selectedOrderItems,
        attachInvoice: data.attachment,
        orderInvoiceStatus:
          statusCount.countToCheck === checkedList?.length
            ? "INVOICED"
            : "PARTIAL",
        commissionRequests: commissionRequests,
        comments: data.comments
      };

      if (
        commissionRequests?.some(
          (data: any) =>
            (isV3CommissionType(allCodeTablesValuesMap, data?.agencyType) ||
              data?.agencyType === "AGENCY" ||
              data?.agencyType === "OVERRIDE") &&
            data?.expectedCommissionAmount <= 0
        )
      ) {
        setShowOptionsPopup({
          message:
            `Service Fee amount for the ${getCodeTableDisplayLabel(allCodeTablesValuesMap, COMMISSION_TYPE_CODETABLE, "V3")}/Agency/Override Agency is missing or zero. Do you still want to proceed with recording the invoice?`,
          show: true,
          variant: "confirm",
          buttons: [
            {
              name: "Confirm",
              color: "primary",
              onClick: async () => {
                const response = await dispatch(
                  addInvoice({
                    invoiceData: invoiceDtoObject,
                    interceptorOption: { skipErrorPopup: true },
                  })
                );
                if (response?.payload?.code === RESPONSE_CODES.SUCCESS_CODE) {
                  let alertMessage = `Invoice ${response?.payload?.data?.mfgInvoiceNumber} recorded successfully.`;//CS-1588 - Updated success message
                  const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                  };
                  dispatch(setSingleAlertObj(alertObj));
                  navigate("/invoice_list");
                } else if (
                  response?.payload?.code === RESPONSE_CODES.FAILED_CODE
                ) {
                  let alertMessage = response.payload?.message;
                  const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "error",
                  };
                  dispatch(setSingleAlertObj(alertObj));
                }
                cancelOptionPopup();
              },
            },
            { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
          ],
        });
      } else {
        const response = await dispatch(
          addInvoice({
            invoiceData: invoiceDtoObject,
            interceptorOption: { skipErrorPopup: true },
          })
        );
        if (response?.payload?.code === RESPONSE_CODES.SUCCESS_CODE) {
          let alertMessage = `Invoice ${response?.payload?.data?.mfgInvoiceNumber} recorded successfully`;
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "success",
          };
          dispatch(setSingleAlertObj(alertObj));
          navigate("/invoice_list");
        } else if (response?.payload?.code === RESPONSE_CODES.FAILED_CODE) {
          let alertMessage = response.payload?.message;
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "error",
          };
          dispatch(setSingleAlertObj(alertObj));
        }
        cancelOptionPopup();
      }
    }
  };

  //CS-1322 - Reseting the orderitems for Create/Record Invoice
  const cancelOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };

  const claimDtoObject: orderItemClaim = {
    claimId: 2,
    claimNumber: "C3156456",
    claimAmount: 22.36,
    claimStatus: "REIMBURSED",
    submittedDate: "05/22/2024",
    reimbursedDate: "06/13/2024",
  };

  useEffect(() => {
    const fetchOrderItems = async () => {
      if (orderItemsListInfo) {
        let count = 0;
        const orderItemsPromises = orderItemsListInfo.map(async (orderItem) => {
          const response = await dispatch(
            getPracticeProductByPracticeProductId({
              practiceProductId: orderItem.practiceProductId,
              productItemId: orderItem.productItemId.toString(),
            })
          );
          const invoicedStatus =
            (orderItem?.tissueTrackingId && orderItem?.invoiceId) ||
            (orderItem?.productReturnId && orderItem?.invoiceId) ||
            (!orderItem?.tissueTrackingId &&
              !orderItem?.productReturnId &&
              orderItem?.invoiceId);
          if (!invoicedStatus) {
            count += 1;
            setStatusCount((prev) => {
              return { ...prev, countToCheck: count };
            });
          }
          return {
            select: <CustomCheckbox control={control} name="select" />,
            orderItemId: orderItem.orderItemId,
            serialNumber: orderItem.serialNumber,
            size: orderItem.size,
            mfgInvoiceNumber: orderItem.mfgInvoiceNumber,
            tissueTrackingId: orderItem.tissueTrackingId,
            productReturnId: orderItem.productReturnId,
            productReturnStatus: orderItem.productReturnStatus,
            claim: modifyClaimObject(claimDtoObject, orderItem.size),
            invoice: orderItem.invoice,
            extendedPrice: response?.payload?.extendedPrice
              ? response.payload.extendedPrice
              : "",
            productItemId: orderItem.productItemId,
            invoiceId: orderItem.invoiceId,
            units: orderItem.units,
            hasSKUPrice: orderItem.hasSKUPrice,
            orderItemPrice: orderItem.orderItemPrice,//CS-1560 - Adding order item price directly from backend
          };
        });
        const orderItems = (await Promise.all(orderItemsPromises)).sort(
          (a, b) => a.units - b.units
        );

        const extendedPrices = orderItems
        .map((item) => item.extendedPrice)
        .filter((price) => price !== "");
        const firstArrayPrice = extendedPrices[0] || "";
        setExtendedPriceInfo(firstArrayPrice);

        const graftList: number[] = [];

        orderItems?.forEach((row) => {
          const status = orderItemStatus(row);
          if (
            status !== "Invoiced" &&
            status !== "Applied (Invoiced)" &&
            status !== "Returned (Invoiced)" &&
            status !== "Return Initiated (Invoiced)" &&
            status !== "Return Pending (Invoiced)" &&
            status !== "Return Rejected (Invoiced)"
          ) {
            graftList.push(row.orderItemId);
          }
        });
        setAvailableGrafts(graftList);
        setOrderItemRow(orderItems);
        setStatusCount((prev) => {
          return { ...prev, orderItemsCount: orderItemsListInfo.length };
        });
      }
    };

    fetchOrderItems();
  }, [orderItemsListInfo]);

  //CS-1567 START
  useEffect(() => {
    if (orderItemRow && orderItemRow.length > 0) {
      // Check if any checkbox is disabled
      const anyDisabled = orderItemRow.some((row) => disableCheckBox(row));
      
      // Only set shipping charge if it hasn't been set yet and no checkboxes are disabled
      const currentShippingCharge = getValues("shippingCharge");
      if ((currentShippingCharge === undefined || currentShippingCharge === null || currentShippingCharge === "") && !anyDisabled) {
        // Extract and set shipping charge only if no checkboxes are disabled
        const orderDetails: OrderInfo = location?.state?.selectedOrderBilling;
        const extractedShippingCharge = resolveShippingCharge(orderDetails);
        if (extractedShippingCharge != null) {
          setValue("shippingCharge", extractedShippingCharge);
        }
      }
    }
  }, [orderItemRow]);
  //

  const handleCheckboxChange = (
    e: any,
    orderItemId: number,
    extendedPrice: number,
    units: number,
    hasSKUPrice: boolean,
    orderItemPrice: number //CS-1560 - Adding order item price directly from backend
  ) => {
    const { checked } = e.target;
    //CS-1560 
    setTotalExtendedPrice((prev) => {
      const newVal = checked
        ? prev + orderItemPrice
        : prev - orderItemPrice;
      // const newVal = checked
      //   ? prev + (hasSKUPrice ? extendedPrice : extendedPrice * units)
      //   : prev - (hasSKUPrice ? extendedPrice : extendedPrice * units);
      setValue("calculatedAmt", newVal);
      return newVal;
    });

    setCheckedList((prev) => {
      let checkedGrafts;
      if (!prev.includes(orderItemId)) {
        checkedGrafts = [...prev, orderItemId];
      } else {
          checkedGrafts = prev.filter((id) => id !== orderItemId);
      };
      setValue('selectAll', checkedGrafts?.length == availableGrafts?.length ? true : false);
      return checkedGrafts;
    });
  };

  const handleMarkedClaimReimbursed = async (claim: orderItemClaim) => {
    const addReimbursedClaimObj: reimburseClaimInfo = {
      claimId: claim.claimId,
      claimAmount: claim.claimAmount ? claim.claimAmount : 0,
      claimStatus: "REIMBURSED",
      reimbursedDate: dayjs(new Date()).format("MM/DD/YYYY"),
    };
    const response = await dispatch(addReimbursedClaim(addReimbursedClaimObj));
  };

  const handleMarkedInvoicePaid = (orderItemId: number) => {
    // setIsInvoicePaid((prevStatuses) => ({
    //   ...prevStatuses,
    //   [orderItemId]: !prevStatuses[orderItemId],
    // }));
  };

const orderItemStatus = useCallback((row: OrderItemRow) => {
    if (row?.tissueTrackingId) {
      if (row?.invoiceId) {
        return "Applied (Invoiced)";
      }
      return "Applied";
    } else if (row?.productReturnId) {
      if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED){
      if (row?.invoiceId) {
        return "Return Initiated (Invoiced)";
      }
      return "Return Initiated";
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING){
      if (row?.invoiceId) {
        return "Return Pending (Invoiced)";
      }
      return "Return Pending";
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED){
      if (row?.invoiceId) {
        return "Return Rejected (Invoiced)";
      }
      return `Available`;
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURNED){
      if (row?.invoiceId) {
        return "Returned (Invoiced)";
      }
      return `Returned`;
    }
    } else if (row?.invoiceId) {
      return "Invoiced";
    }
    return "Available";
  }, []);

  //CS-1191 - Start
  const getStatusChipSx = (status: string) => {
    if (status?.includes("Applied")) return { backgroundColor: "rgba(20,184,166,0.15)", color: "#14b8a6", border: "1px solid rgba(20,184,166,0.4)", fontWeight: 700 };
    if (status === "Available") return { backgroundColor: "rgba(40,167,69,0.15)", color: "#28a745", border: "1px solid rgba(40,167,69,0.4)", fontWeight: 700 };
    if (status?.includes("Return Initiated")) return { backgroundColor: "rgba(0,184,217,0.15)", color: "#00B8D9", border: "1px solid rgba(0,184,217,0.4)", fontWeight: 700 };
    if (status?.includes("Return Pending")) return { backgroundColor: "rgba(255,171,0,0.15)", color: "#FFAB00", border: "1px solid rgba(255,171,0,0.4)", fontWeight: 700 };
    if (status?.includes("Return") || status?.includes("Returned")) return { backgroundColor: "rgba(220,53,69,0.15)", color: "#dc3545", border: "1px solid rgba(220,53,69,0.4)", fontWeight: 700 };
    if (status?.includes("Invoiced")) return { backgroundColor: "rgba(37,99,235,0.15)", color: "#2563EB", border: "1px solid rgba(37,99,235,0.4)", fontWeight: 700 };
    return { backgroundColor: "rgba(253,126,20,0.15)", color: "#fd7e14", border: "1px solid rgba(253,126,20,0.4)", fontWeight: 700 };
  };

  const renderOrderItemStatus = useCallback(
    (row: OrderItemRow): string | JSX.Element => {
      const status = orderItemStatus(row);

      const shouldShowInvoiceLink =
        ["Invoiced", "Applied (Invoiced)", "Returned (Invoiced)","Return Initiated (Invoiced)","Return Pending (Invoiced)","Return Rejected (Invoiced)"].includes(
          status
        ) && row?.mfgInvoiceNumber;

      const statusChip = (
        <Chip
          label={status}
          size="small"
          sx={{
            ...getStatusChipSx(status),
            fontSize: "0.7rem",
            height: 22,
            maxWidth: "100%",
            "& .MuiChip-label": {
              px: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
              lineHeight: "20px",
            },
          }}
        />
      );

      if (shouldShowInvoiceLink) {
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 0.35,
              minWidth: 0,
              py: 0.1
            }}
          >
            {statusChip}
            <Link
              component="button"
              underline="hover"
              onClick={() =>
                navigate("/billing_detail", {
                  state: { invoiceId: row.invoiceId },
                })
              }
              sx={{
                fontSize: "0.72rem",
                fontWeight: 600,
                color: "#42A5F5",
                lineHeight: 1.2,
                p: 0.5,
                m: 0,
                textAlign: "left",
                whiteSpace: "nowrap",
              }}
            >
              ({row?.mfgInvoiceNumber})
            </Link>
          </Box>
        );
      }

      return statusChip;
    },
    [orderItemStatus, navigate]
  );
  //CS-1191 - End

  const caUpdateOrderClaim = useSelector((state: RootState) =>
    selectIsTokenAvailable("caUpdateOrderClaim")(state)
  );
  const caUpdateOrderInvoice = useSelector((state: RootState) =>
    selectIsTokenAvailable("caUpdateOrderInvoice")(state)
  );

  const handleCheckboxEnableDisable = (row: any) => {
    if (row.claim && caUpdateOrderClaim) {
      if (row.claim && row.claim.claimStatus) {
        return true;
      } else {
        return false;
      }
    } else if (row.invoice && caUpdateOrderInvoice) {
      if (row.invoice && row.invoice.mfgInvoiceStatus) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const disableCheckBox = (row: OrderItemRow) => {
    const status = orderItemStatus(row);
    if (
      status === "Invoiced" ||
      status === "Applied (Invoiced)" ||
      status === "Returned (Invoiced)" ||
      status === "Return Initiated (Invoiced)" ||
      status === "Return Pending (Invoiced)" ||
      status === "Return Rejected (Invoiced)"
    ) {
      return true;
    }
    return false;
  };

  const handleDropzoneChange = async (
    uploadedFiles: ExtendedFile[],
    fieldName: any
  ) => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      const base64File = String(await convertBase64(uploadedFiles[0]));
      const fileName = uploadedFiles[0].name;
      const fileExtension = fileName
        .slice(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      const base64Substring = base64File.substring(
        fileExtension === "pdf"
          ? "data:application/pdf;base64,".length
          : "data:image/png;base64,".length,
        base64File.length
      );
      const attachmentObj: Attachment[] = [
        {
          content: base64Substring,
          documentName: fileName,
          fileType: fileExtension,
          type: "INVOICE",
        },
      ];
      setValue("attachment", attachmentObj);
    }
  };

  const handleDeleteFile = () => {
    setValue("attachment", []);
  };

  const handleSelectAllCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (checked) {
      const selectList: number[] = [];
      let invAmt: number = 0;
      orderItemRow?.forEach((row) => {
        const status = orderItemStatus(row);
        if (
          status !== "Invoiced" &&
          status !== "Applied (Invoiced)" &&
          status !== "Returned (Invoiced)" &&
          status !== "Return Initiated (Invoiced)" &&
          status !== "Return Pending (Invoiced)" &&
          status !== "Return Rejected (Invoiced)"
        ) {
          selectList.push(row.orderItemId);
          invAmt += row.orderItemPrice; //CS-1560 - Adding order item price directly from backend
          // invAmt += row.hasSKUPrice
          //   ? row.extendedPrice
          //   : row.extendedPrice * row.units;
        }
      });
      setTotalExtendedPrice(invAmt);
      setValue("calculatedAmt", invAmt);
      setCheckedList(selectList);
    } else {
      setCheckedList([]);
      setTotalExtendedPrice(0);
      setValue("calculatedAmt", 0);
    }
  };

  const handleDatechange = (date: any) => {
    if (date) {
      setValue(
        "invoiceDueDate",
        dayjs(date).add(invoiceNetdays, "day").format("MM/DD/YYYY")
      );
    }
  };
  //CS-1191-START
  //   const renderCommissionAmountField = (
  //   row: any, index: any
  // ): JSX.Element => {
  //   return (
  //     <>
  //       <CustomCurrencyField
  //         id={`commissionAmt-${index}`}
  //         controllerName={`commissionAmt-${index}`}
  //         control={control}
  //         rules={
  //           row?.agencyType === "V3"
  //             ? {
  //                 required: "V3 Commission Amount is required.",
  //               }
  //             : {}
  //         }
  //       />
  //     </>
  //   );
  // };

  // const handleActionEdit = (row: any, rowIndex: number) => {
  //   setEditCommission(true);
  //   setSelectedAssociateType(row.associateAgencyId ? "AGENCY" : row.associateType)
  //   if (row?.agencyType === "OVERRIDE") {
  //     setIsCommTypeOverride(true);
  //   } else {
  //     setIsCommTypeOverride(false);
  //   }
  //  const isEditing = Boolean(row?.agencyId);
  //  if(isEditing){
  //   setAgencyData({agencyId:row?.agencyId , isEditing:isEditing})
  //  }

  //   const selectedCommission: any = {
  //     productCommissionId: row.productCommissionId,
  //     productId: row.productId === undefined ? undefined : Array.isArray(row.productId) ? row.productId : [row.productId],
  //     productName: row.productName,
  //     associateType:row.associateAgencyId? "AGENCY" :row.associateType,
  //     associateAgencyId: row.associateAgencyId,
  //     associatePracticeId: row.associatePracticeId,
  //     associateAccountRepId: row.associateAccountRepId,
  //     commissionRate: row.commissionRate ? Number(row.commissionRate.toString().split(" ")[0]) : "",
  //     commissionPayTerms: row.commissionPayTerms,
  //     associateAgencyName: row.associateAgencyName,
  //     associatePracticeName: row.associatePracticeName,
  //     associateAccountRepName: row.associateAccountRepName,
  //     associateAgencyCommission: row.associateAgencyCommission,
  //     effectiveDate: row.effectiveDate,
  //     inactiveDate: row.inactiveDate,
  //     rowIndex: row.rowIndex
  //   }
  //   setSelectedCommission(selectedCommission);
  //   setOpen(true);
  // }
  //CS-1191 - START
  const handleEditCommissionData = (data: any) => {
    if (watch("invoiceAmt") > 0) {
      setShowEditCommissionPopup(true);
      setAgencyData({ ...data, invoiceAmt: getValues("invoiceAmt") });
    } else {
      let alertMessage =
        "Please enter invoice amount before editing service fee data.";
      const alertObj: SingleAlertInfo = {
        message: alertMessage,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
  };
  const handleOvrCommissionPopup = () => {
    if (watch("invoiceAmt") > 0) {
      setShowOvrCommissionPopup(true);
    } else {
      let alertMessage =
        "Please enter invoice amount before adding new ovr service fee data.";
      const alertObj: SingleAlertInfo = {
        message: alertMessage,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
  };

  const invoiceAmt = Number(watch("invoiceAmt") || 0);
  const shippingCharge = Number(watch("shippingCharge") || 0);
  const lateFee = Number(watch("lateFee") || 0);
  const totalAmount = invoiceAmt + shippingCharge + lateFee;

  //CS-1191 - END
  const commissionActionButtons = (row: any, index: any): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          onClick={() => handleEditCommissionData(row)} //handleActionEdit(row, index)
          style={{
            display: hideElement(row?.productCommissionId ? false : true),
          }}
        >
          <Edit fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          tooltipMessage="Delete"
          tooltipPlacement="top"
          onClick={() => {
            setCombinedCommissionData((prevData) =>
              prevData.filter((item) => item.agencyId !== row.agencyId)
            );
            setNewOvrCommissionData((prevData: any) =>
              prevData.filter((item: any) => item.agencyId !== row.agencyId)
            );
          }}
          style={{
            display: hideElement(
              row?.productCommissionId === null &&
                row?.agencyType === "OVERRIDE"
                ? false
                : true
            ),
          }}
        >
          <Delete fontSize="small" />
        </CustomIconButton>
        {row?.agencyType !== "OVERRIDE" && (
          <CustomIconButton
            color="success"
            size="small"
            variant="outlined"
            tooltipMessage="Add"
            tooltipPlacement="top"
            onClick={() => {
              dispatch(clearAddAgencyProductCommissionStatus());
              const initialCommission: Row = {
                productCommissionId: 0,
                productId: [product.productId],
                productName: undefined,
                associateType: undefined,
                associateAgencyId: undefined,
                associatePracticeId: undefined,
                associateAccountRepId: undefined,
                commissionRate: undefined,
                commissionPayTerms: undefined,
                associateAgencyName: undefined,
                associatePracticeName: undefined,
                associateAccountRepName: undefined,
                associateAgencyCommission: undefined,
                effectiveDate: undefined,
                inactiveDate: undefined,
                rowIndex: index
              }
              setSelectedCommission(initialCommission);
              setSelectedAgency(row.agencyId);
              setOpen(true);
            }}
            style={{
              display: hideElement(row?.productCommissionId !== null),
            }}
          >
            <Add fontSize="small" />
          </CustomIconButton>
        )}
      </>
    );
  };

  //CS-1191 - START
  useEffect(() => {
    const apiData = applyInvDetail?.commissionDetail ?? [];

    const newEntries = Array.isArray(newOvrCommissionData)
      ? newOvrCommissionData
      : [];
    const specificUpdates = Array.isArray(newInvSpecificCommissionData)
      ? newInvSpecificCommissionData
      : [];

    // Filter out any items that do not have a valid productCommissionId
    const validUpdates = [...specificUpdates].filter(
      (item) => item.productCommissionId != null
    );

    const updatesById = validUpdates.reduce((acc, item) => {
      acc[item.productCommissionId] = item;
      return acc;
    }, {} as Record<string | number, any>);

    // Replace specific items, only if there's a valid update
    const merged = apiData.map((item) =>
      item.productCommissionId != null && updatesById[item.productCommissionId]
        ? updatesById[item.productCommissionId]
        : item
    );

    // Add new entries (OVR + Specific) which are not in the original data
    const newOnly = [...newEntries, ...specificUpdates].filter(
      (item) =>
        !item.productCommissionId ||
        !apiData.some(
          (orig) => orig.productCommissionId === item.productCommissionId
        )
    );

    setCombinedCommissionData([...merged, ...newOnly]);
  }, [applyInvDetail, newOvrCommissionData, newInvSpecificCommissionData]);
  // useEffect(() => {
  //   const apiData = applyInvDetail?.commissionDetail ?? [];
  //   const newEntries = Array.isArray(newOvrCommissionData) ? newOvrCommissionData : [];
  //   const specificUpdates = Array.isArray(newInvSpecificCommissionData) ? newInvSpecificCommissionData : [];

  //   // Combine updates into one reference list
  //   const updatesById = [...newEntries, ...specificUpdates].reduce((acc, item) => {
  //     acc[item.productCommissionId] = item;
  //     return acc;
  //   }, {} as Record<string, any>);

  //   // Replace or keep original
  //   const merged = apiData.map(item =>
  //     updatesById[item.productCommissionId] ? updatesById[item.productCommissionId] : item
  //   );

  //   // Add any new items not already in the original apiData
  //   const newOnly = [...newEntries, ...specificUpdates].filter(
  //     item => !apiData.some(orig => orig.productCommissionId === item.productCommissionId)
  //   );

  //   // Final combined list
  //   setCombinedCommissionData([...merged, ...newOnly]);

  // }, [applyInvDetail, newOvrCommissionData, newInvSpecificCommissionData]);
  //CS-1191 - END
  const commissionSummaryRows: any[] = useMemo(() => {
    const rows: any[] = [];
    combinedCommissionData.forEach((item: any, index: any) => {
      //CS-1213 - Start
      const commAMount = calculateCommissionAmount(
        Number(getValues("invoiceAmt")),
        Number(item.commissionRate)
      );
      const row = {
        id: item.productCommissionId,
        type: getCodeTableDisplayLabel(
          allCodeTablesValuesMap,
          COMMISSION_TYPE_CODETABLE,
          item.agencyType
        ),
        agency:
          item.productCommissionId && item.agencyType === "OVERRIDE"
            ? `${item.agencyName} (${item.associateType})`
            : item.agencyName,
        commissionPercent:
          item?.commissionRate !== null
            ? `${formatValue(Number(item.commissionRate), { suffix: "%" })}`
            : "-",
        commissionAmount: (
          <span style={{ cursor: "pointer" }} title={commAMount.toString()}>
            {formatValue(commAMount, { prefix: "$" })}
          </span>
        ),
        actionButtons: commissionActionButtons(item, index),
      };
      //CS-1213 - End
      setValue(
        `commissionAmt-${index}`,
        item?.commissionAmt ||
          calculateCommissionAmount(
            getValues("invoiceAmt"),
            Number(item.commissionRate)
          )
      );
      rows.push(row);
    });
    return rows;
  }, [combinedCommissionData, watch("invoiceAmt"), allCodeTablesValuesMap]);

  const orderGraftRows: any[] = useMemo(() => {
    const rows: any[] = [];
    orderItemRow.map((item: any, index: any) => {
      const row = {
        checkBox: (
          <CustomCheckbox
            onChange={(e) =>
              handleCheckboxChange(
                e,
                item.orderItemId,
                item.extendedPrice,
                item.units,
                item.hasSKUPrice,
                item.orderItemPrice,//CS-1560
              )
            }
            control={control}
            name={`select-${item.orderItemId}`}
            checked={checkedList.includes(item.orderItemId)}
            isDisabled={disableCheckBox(item)}
          />
        ),
        orderSize: item.size,
        serialNumber: item.serialNumber,
        status: renderOrderItemStatus(item),
        //CS-1560 - Removing the calculation now it will be directly fetched from backend
        cogs: priceFormatter(
          item.orderItemPrice),
        // cogs: priceFormatter(
        //   item.hasSKUPrice
        //     ? item.extendedPrice
        //     : item.extendedPrice * item.units
        // ),
      };
      rows.push(row);
    });
    return rows;
  }, [orderItemRow, checkedList]);

  const handleClose = () => {
    setShowOvrCommissionPopup(false);
    setShowEditCommissionPopup(false);
    setAgencyData({});
  };

  const handleCloseCommissionPopup = () => {
    setOpen(false);
    setEditCommission(false);
    setSelectedAssociateType('')
  };

  const handleSaveAgencyProductCommission = async (data: ProductCommissionAgency) => {
    let errorObj: MainErrorInfo = {
      title: "",
    };

    try {
      const response = await dispatch(addAgencyProductCommission(data));

      if (response.payload && response.payload.message === 'SUCCESS') {
        const alertObj: SingleAlertInfo = {
          message: "Agency Product Service Fee Created Successfully!",
          alertType: "success",
        };

        const updatedCommissionList: ProductCommissionAgency[] = [...combinedCommissionData];
        let changedCommission: ProductCommissionAgency = {
          ...updatedCommissionList[data.rowIndex],
          productId: data.productId,
          // productName: data.productName,
          commissionRate: data.commissionRate,
          commissionPayTerms: data.commissionPayTerms,
          associateAgencyId: data.associateAgencyId,
          associatePracticeId: data.associatePracticeId,
          associateAccountRepId: data.associateAccountRepId,
          effectiveDate: data.effectiveDate,
          inactiveDate: data.inactiveDate,
        }

        updatedCommissionList[data.rowIndex] = changedCommission;
        setCombinedCommissionData(updatedCommissionList);

        dispatch(setSingleAlertObj(alertObj));
      } else {
        let errorSentence = '';
        if (response.payload.errors.length <= 0) {
          errorSentence = response.payload.message || "An unknown error occurred.";
        } else {
          response.payload.errors.forEach((error: any, index: any) => {
            if (error.field) {
              errorSentence += `${error.field}: ${error.errorMessage}\n`;
            } else {
              errorSentence += `${error.reason}\n`;
            }
          });
        }

        errorObj.title = editCommission ? "Agency Product Service Fee Update Failed!" : "Agency Product Service Fee Creation Failed!";
        errorObj.errorMessageStream = errorSentence;
        dispatch(setMainErrorObj(errorObj));
      }
    } catch (error) {
      console.log("Error creating agency product commission :", error);
      errorObj.title = editCommission ? "Error updating agency product service fee" : "Error creating agency product service fee";
      errorObj.errorMessageStream = "" + error;
      dispatch(setMainErrorObj(errorObj));
    }
  };

  const submitCommission = (commission: ProductCommissionAgency) => {

    let notValidCommission = false;
    let errorMsg = "";

    let newEffectiveDate = commission.effectiveDate ? moment(commission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "";
    let newInativeDate = commission.inactiveDate ? moment(commission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "";

    if (newInativeDate === "Invalid date") {
      notValidCommission = true;
      errorMsg = "Inactive Date is Invalid";
    }

    if (newEffectiveDate === "Invalid date") {
      notValidCommission = true;
      errorMsg = "Effective Date is Invalid";
    }

    if (newInativeDate !== "" && newInativeDate !== "Invalid date" && newEffectiveDate !== "Invalid date" && new Date(newEffectiveDate) > new Date(newInativeDate)) {
      notValidCommission = true;
      errorMsg = "Effective Date should be less than Inactive Date";
    }

    if (notValidCommission) {
      let errorObj: MainErrorInfo = {
        title: "",
      };

      errorObj.title = editCommission ? "Error updating agency product service fee" : "Error creating agency product service fee";
      errorObj.errorMessageStream = errorMsg;
      setOpen(false);
      dispatch(setMainErrorObj(errorObj));
      return;
    }

    const productIds = Array.isArray(commission.productId) ? commission.productId : [commission.productId];

    for (const singleProductId of productIds) {
      const singleCommission: ProductCommissionAgency = {
        ...commission,
        productId: singleProductId,
        agencyId: selectedAgency,
        inactiveDate: commission.inactiveDate ? moment(commission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "",
        effectiveDate: commission.effectiveDate ? moment(commission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "",
        commissionRate: commission.commissionRate ? Number(commission.commissionRate) : 0
      };

      if (!isCommTypeOverride) {
        delete singleCommission.associateAgencyId;
      }

      handleSaveAgencyProductCommission(singleCommission);
    }

    setOpen(false);
    setEditCommission(false);
    setSelectedAssociateType('');
  };

  const productOptions = useMemo(() => {
    let options: Option[] = [];
    if (product) {
      console.log(product);
      options.push({ label: product.manufacturerName + " - " + product.productName, value: product.productId })
    };
    return options;
  }, [product]);

  const associateAgencyOptions = useMemo(() => {
    let options: AgencyOption[] = [];
    if (associateAgencyList) {
      const sortedAgencyList: CreateSearchAgency[] = sortNames(associateAgencyList, 'agencyName');
      sortedAgencyList?.forEach((option) => {
        if (option.agencyName !== undefined && option.agencyId !== undefined) {
          if (isCommTypeOverride && option.agencyId === agencyData.agencyId) {
            return; // This acts like 'continue' by skipping to the next iteration
          }
          options.push({ label: option.agencyName, value: option.agencyId });
        }
      });
    };
    return options;
  }, [associateAgencyList, isCommTypeOverride]);

  const AssociateOptions = [PRACTICE_ENTITY, ACCOUNT_REPRESENTATIVE_ENTITY, AGENCY_ENTITY]

  const associateOptions = useMemo<Option[]>(() => {
    let options: Option[] = [];
    if (AssociateOptions && AssociateOptions.length > 0) {
      options = AssociateOptions.map((option) => ({
        value: option,
        label: option,
      }));
    }
    return options;
  }, [AssociateOptions]);

  const agencyExecutivesOptions = useMemo(() => {
    let options: any[] = [];
    agencyExecutives?.map((executive) => {
      options.push({
        value: executive.userId,
        label:
          // executive.agencyName +
          // " - " +
          fullName(
            null,
            executive.firstName,
            executive.middleName,
            executive.lastName
          ),
      });

    });

    return options;
  }, [agencyExecutives])

  const practiceListOptions = useMemo(() => {
    let options: Option[] = [];
    if (practiceByUserRoleAgencySlice && practiceByUserRoleAgencySlice.length > 0) {
      const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRoleAgencySlice, 'practiceName');
      sortedPracticeInfo?.map(practice => {
        options.push({ value: practice.practiceId, label: practice.practiceName });
      });
    }
    return options;
  }, [practiceByUserRoleAgencySlice]);

  //CS-1191-END
  const FieldLabel = ({ label, required = false }: { label: string; required?: boolean }) => (
    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.4 }}>
      {label}{required && <Box component="span" sx={{ color: mTokens.accent }}>*</Box>}
    </Typography>
  );

  const InfoRow = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <Box display="flex" alignItems="center" py={0.8} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" } }}>
      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "40%", flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1 }} component="div">
        {value ?? "—"}
      </Typography>
    </Box>
  );

  const colHeaderSx = {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: mTokens.textSecondary,
    textTransform: "uppercase" as const,
    letterSpacing: "0.08em",
  };
  const colBodySx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 };

  return (
    <>
      {showOvrCommissionPopup && (
        <OVRCommissionPopup
          open={showOvrCommissionPopup}
          handleClose={handleClose}
          onAddOvrCommission={(commission) => {
            setNewOvrCommissionData((prevCommission: any) => [
              ...prevCommission,
              commission,
            ]);
          }}
          agencyData={combinedCommissionData}
        />
      )}
      {showEditCommissionPopup && (
        <EditCommissionPopup
          open={showEditCommissionPopup}
          handleClose={handleClose}
          onAddInvSpecificCommission={(commission) => {
            setNewInvSpecificCommissionData((prevCommission: any) => [
              ...prevCommission,
              commission,
            ]);
          }}
          agencyData={agencyData}
        />
      )}
      <Box
        sx={{
          mx: { xs: "10px", sm: "20px" },
          mt: "12px",
          // Clear the fixed footer so action buttons / last rows stay reachable
          pb: "72px",
        }}
      >
        {showOptionPopup.show && (
          <OptionsPopup
            open={showOptionPopup.show}
            onClose={() => setShowOptionsPopup({ message: "", show: false })}
            variant={showOptionPopup.variant}
            message={<>{showOptionPopup.message}</>}
            buttons={showOptionPopup.buttons}
            title={showOptionPopup.title}
            obj={showOptionPopup.obj}
          />
        )}

        {/* Page Header */}
        <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
          <PageBackButton tooltip={null} />
          <Box>
            <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
              Billing / Apply Invoice
            </Typography>
            <Typography sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
              Apply Invoice
            </Typography>
            <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mt: 0.4 }}>
              Select items, review service fees, and apply invoice details.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" }, gap: 1.5, alignItems: "flex-start" }}>
          {/* Left column */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, order: { xs: 1, md: 1 } }}>
            {/* Grafts */}
            <Box sx={cardSx}>
              <SectionHeader icon={<Inventory2Outlined fontSize="small" />} title="Grafts" />
              <Box>
                <span data-testid="row-count" style={{ display: "none" }}>{orderGraftRows.length}</span>
                {isNarrow ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      px: 2,
                      py: 0.8,
                      borderBottom: `1px solid ${mTokens.border}`,
                      backgroundColor: mTokens.headerFooterBg,
                    }}
                  >
                    <CustomCheckbox
                      control={control}
                      onChange={(e) => handleSelectAllCheckbox(e)}
                      controllerName="selectAll"
                    />
                    <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: mTokens.textSecondary }}>
                      Select all available
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "48px minmax(90px, 1fr) minmax(110px, 1.2fr) minmax(120px, 1.4fr) minmax(80px, 0.9fr)",
                      gap: 1,
                      px: 2.8,
                      py: 0.8,
                      borderBottom: `1px solid ${mTokens.border}`,
                      backgroundColor: mTokens.headerFooterBg,
                    }}
                  >
                    <Box>
                      <CustomCheckbox
                        control={control}
                        onChange={(e) => handleSelectAllCheckbox(e)}
                        controllerName="selectAll"
                      />
                    </Box>
                    <Typography sx={colHeaderSx}>Ordered Size</Typography>
                    <Typography sx={colHeaderSx}>Serial Number</Typography>
                    <Typography sx={colHeaderSx}>Status</Typography>
                    <Typography sx={{ ...colHeaderSx, textAlign: "right" }}>COGs</Typography>
                  </Box>
                )}
                {orderGraftRows.length === 0 ? (
                  <Box sx={{ px: 2.8, py: 3, textAlign: "center" }}>
                    <Typography sx={{ fontSize: "0.88rem", color: mTokens.textSecondary }}>No grafts available</Typography>
                  </Box>
                ) : (
                  orderGraftRows.map((row: any, index: number) => {
                    const rowBorder = index < orderGraftRows.length - 1 ? `1px dashed ${mTokens.border}` : "none";
                    return (
                      <Box key={`graft-${index}`} data-testid={`row-${index}`}>
                        {isNarrow ? (
                          <Box sx={{ px: 2, py: 1.2, borderBottom: rowBorder }}>
                            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.2 }}>
                              <Box sx={{ pt: 0.2, flexShrink: 0 }}>{row.checkBox}</Box>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, mb: 0.4 }}>
                                  <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, color: mTokens.textPrimary }}>
                                    {row.orderSize}
                                  </Typography>
                                  <Typography sx={{ fontSize: "0.88rem", fontWeight: 700, color: mTokens.accent, flexShrink: 0 }}>
                                    {row.cogs}
                                  </Typography>
                                </Box>
                                {row.serialNumber ? (
                                  <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mb: 0.5 }}>
                                    SN: {row.serialNumber}
                                  </Typography>
                                ) : null}
                                <Box>{row.status}</Box>
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "48px minmax(90px, 1fr) minmax(110px, 1.2fr) minmax(120px, 1.4fr) minmax(80px, 0.9fr)",
                              gap: 1,
                              px: 2.8,
                              py: 1.2,
                              borderBottom: rowBorder,
                              alignItems: "flex-start",
                            }}
                          >
                            <Box sx={{ pt: 0.2 }}>{row.checkBox}</Box>
                            <Typography sx={{ ...colBodySx, pt: 0.35 }}>{row.orderSize}</Typography>
                            <Typography sx={{ ...colBodySx, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pt: 0.35 }}>
                              {row.serialNumber || "—"}
                            </Typography>
                            <Box sx={{ minWidth: 0 }}>{row.status}</Box>
                            <Typography sx={{ ...colBodySx, fontWeight: 700, color: mTokens.accent, textAlign: "right", pt: 0.35 }}>
                              {row.cogs}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  })
                )}
              </Box>
            </Box>

            {/* Commissions */}
            <Box sx={cardSx}>
              <SectionHeader
                icon={<AccountBalanceWalletOutlined fontSize="small" />}
                title="Service Fees"
                action={
                  <Box
                    component="button"
                    type="button"
                    onClick={() => handleOvrCommissionPopup()}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                      px: 1.4,
                      height: 32,
                      border: "1px solid rgba(20,184,166,0.55)",
                      borderRadius: "10px",
                      backgroundColor: "transparent",
                      color: "#14b8a6",
                      cursor: "pointer",
                      fontSize: "0.78rem",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                      transition: "all 0.2s",
                      "&:hover": { backgroundColor: "rgba(20,184,166,0.1)" },
                      "& svg": { fontSize: "0.95rem" },
                    }}
                  >
                    <AddCircleOutlineOutlined sx={{ fontSize: "0.95rem" }} />
                    OVR Service Fee
                  </Box>
                }
              />
              <Box>
                <span data-testid="row-count" style={{ display: "none" }}>{commissionSummaryRows.length}</span>
                {!isNarrow && (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "minmax(70px, 0.8fr) minmax(120px, 1.4fr) minmax(70px, 0.7fr) minmax(90px, 0.9fr) minmax(90px, 0.8fr)",
                      gap: 1,
                      px: 2.8,
                      py: 0.8,
                      borderBottom: `1px solid ${mTokens.border}`,
                      backgroundColor: mTokens.headerFooterBg,
                    }}
                  >
                    <Typography sx={colHeaderSx}>Type</Typography>
                    <Typography sx={colHeaderSx}>Agency</Typography>
                    <Typography sx={{ ...colHeaderSx, textAlign: "right" }}>Rate (%)</Typography>
                    <Typography sx={{ ...colHeaderSx, textAlign: "right" }}>Amount ($)</Typography>
                    <Typography sx={{ ...colHeaderSx, textAlign: "center" }}>Action</Typography>
                  </Box>
                )}
                {commissionSummaryRows.length === 0 ? (
                  <Box sx={{ px: 2.8, py: 3, textAlign: "center" }}>
                    <Typography sx={{ fontSize: "0.88rem", color: mTokens.textSecondary }}>No service fees found</Typography>
                  </Box>
                ) : (
                  commissionSummaryRows.map((row: any, index: number) => {
                    const rowBorder = index < commissionSummaryRows.length - 1 ? `1px dashed ${mTokens.border}` : "none";
                    return (
                      <Box key={`comm-${index}`}>
                        {isNarrow ? (
                          <Box sx={{ px: 2, py: 1.2, borderBottom: rowBorder }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, mb: 0.4 }}>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, color: mTokens.textPrimary }}>
                                  {row.agency}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem", color: mTokens.textSecondary, mt: 0.2 }}>
                                  {row.type}
                                </Typography>
                              </Box>
                              <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                                {row.actionButtons}
                              </Box>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.6 }}>
                              <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary }}>
                                Rate: <Box component="span" sx={{ fontWeight: 700, color: mTokens.textPrimary }}>{row.commissionPercent}</Box>
                              </Typography>
                              <Typography sx={{ fontSize: "0.88rem", fontWeight: 700, color: mTokens.textPrimary }}>
                                {row.commissionAmount}
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "minmax(70px, 0.8fr) minmax(120px, 1.4fr) minmax(70px, 0.7fr) minmax(90px, 0.9fr) minmax(90px, 0.8fr)",
                              gap: 1,
                              px: 2.8,
                              py: 1.2,
                              borderBottom: rowBorder,
                              alignItems: "center",
                            }}
                          >
                            <Typography sx={colBodySx}>{row.type}</Typography>
                            <Typography sx={{ ...colBodySx, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {row.agency}
                            </Typography>
                            <Typography sx={{ ...colBodySx, textAlign: "right" }}>{row.commissionPercent}</Typography>
                            <Typography sx={{ ...colBodySx, fontWeight: 700, textAlign: "right" }}>{row.commissionAmount}</Typography>
                            <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                              {row.actionButtons}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    );
                  })
                )}
              </Box>
            </Box>
          </Box>

          {/* Right column */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, order: { xs: 2, md: 2 } }}>
            {/* Details */}
            <Box sx={cardSx}>
              <SectionHeader icon={<PersonOutlined fontSize="small" />} title="Details" />
              <Box sx={{ px: 2.8, py: 1.5 }}>
                <InfoRow label="Patient" value={orderInfo?.patientName} />
                <InfoRow label="Product" value={orderInfo ? `${orderInfo.productName} (${orderInfo.manufacturerName})` : undefined} />
                <InfoRow label="Order ID" value={orderInfo?.orderNumber} />
                <InfoRow label="Extended Price" value={priceFormatter(Number(extendedPriceInfo))} />
              </Box>
            </Box>

            {/* Invoice Details form */}
            <Box sx={cardSx}>
              <SectionHeader icon={<ReceiptLongOutlined fontSize="small" />} title="Invoice Details" />
              <Box sx={{ px: 2.8, pt: 1.8, pb: 2.8 }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="MFG Invoice #" required />
                      <Box sx={inputFieldSx(!!errors.mfgInvoice)}>
                        <CustomTextField
                          controllerName="mfgInvoice"
                          control={control}
                          label=""
                          size="small"
                          rules={
                            submitAction === "markInvoiced"
                              ? {
                                  required:
                                    "Manufacturer Invoice Number is required",
                                }
                              : {}
                          }
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Calculated Amt" />
                      <Box sx={inputFieldSx()}>
                        <CustomCurrencyField
                          label=""
                          controllerName="calculatedAmt"
                          control={control}
                          isDisabled
                          size="small"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Invoice Amt" required />
                      <Box sx={inputFieldSx(!!errors.invoiceAmt)}>
                        <CustomCurrencyField
                          controllerName="invoiceAmt"
                          control={control}
                          label=""
                          size="small"
                          rules={
                            submitAction === "markInvoiced"
                              ? {
                                  required: "Invoice amount is required",
                                  validate: (value: any) =>
                                    parseFloat(value) > 0 ||
                                    "Invoice amount must be greater than 0",
                                }
                              : {
                                  validate: (value: any) =>
                                    parseFloat(value) > 0 ||
                                    "Invoice amount must be greater than 0",
                                }
                          }
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Shipping Charge" />
                      <Box sx={inputFieldSx()}>
                        <CustomCurrencyField
                          controllerName="shippingCharge"
                          control={control}
                          label=""
                          size="small"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Late Fee" />
                      <Box sx={inputFieldSx()}>
                        <CustomCurrencyField
                          controllerName="lateFee"
                          control={control}
                          label=""
                          size="small"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={2}
                        py={1.4}
                        borderRadius="12px"
                        sx={{
                          backgroundColor: "rgba(16,185,129,0.1)",
                          border: "1px solid rgba(16,185,129,0.35)",
                        }}
                      >
                        <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, color: mTokens.textPrimary }}>
                          Total
                        </Typography>
                        <Typography
                          sx={{ fontSize: "1.15rem", fontWeight: 800, color: "#10B981" }}
                        >
                          {priceFormatter(totalAmount)}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Invoiced Date" required />
                      <Box sx={datepickerWrapSx(!!errors.invoicedDate)}>
                        <CustomDatePicker
                          controllerName="invoicedDate"
                          control={control}
                          label=""
                          size="small"
                          rules={
                            submitAction === "markInvoiced"
                              ? { required: "Invoice date is required" }
                              : {}
                          }
                          onChange={handleDatechange}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Invoice Due Date" />
                      <Box sx={datepickerWrapSx()}>
                        <CustomDatePicker
                          controllerName="invoiceDueDate"
                          control={control}
                          label=""
                          size="small"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <FieldLabel label="Comments" />
                      <Box sx={inputFieldSx()}>
                        <CustomTextField
                          control={control}
                          controllerName="comments"
                          label=""
                          size="small"
                          multiline
                          rows={3}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Dropzone
                        name="invoiceAttachment"
                        onFileChange={() => {}}
                        onFileChangeTest={handleDropzoneChange}
                        onDeleteFile={handleDeleteFile}
                        control={control}
                        maxFileCount={1}
                        customDropzoneText="Upload Invoice PDF"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        flexDirection={{ xs: "column", sm: "row" }}
                        gap={1.2}
                      >
                        <Button
                          fullWidth
                          size="large"
                          startIcon={<CheckCircleOutline />}
                          type="submit"
                          removeUpperCase
                          onClick={() => {
                            setSubmitAction("markInvoiced");
                          }}
                          sx={{
                            ...primaryBtnSx,
                            flex: { sm: 1 },
                            backgroundColor: mTokens.accent,
                            boxShadow: "0 4px 18px rgba(20,184,166,.35)",
                            "& .MuiTypography-root": { color: "#ffffff !important" },
                            "& .MuiButton-startIcon": { color: "#ffffff" },
                          }}
                        >
                          Record Invoice
                        </Button>
                        <Button
                          fullWidth
                          color="error"
                          variant="outlined"
                          removeUpperCase
                          startIcon={<Cancel />}
                          onClick={() => navigate(-1)}
                          sx={{
                            ...cancelBtnSx,
                            flex: { sm: 1 },
                            "& .MuiTypography-root": { color: `${mTokens.error} !important` },
                            "& .MuiButton-startIcon": { color: mTokens.error },
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
                <ProductCommissionPopup
                  open={open}
                  selectedAssociateTypeOption={selectedAssociateType}
                  setSelectedAssociateType={setSelectedAssociateType}
                  productOptions={productOptions}
                  associateAgencyOptions={associateAgencyOptions}
                  associateOptions={associateOptions}
                  agencyExecutivesOptions={agencyExecutivesOptions}
                  practiceListOptions={practiceListOptions}
                  isCommTypeOverride={isCommTypeOverride}
                  editCommission={editCommission}
                  defaultValue={selectedCommission}
                  handleClose={handleCloseCommissionPopup}
                  submitCommission={submitCommission}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Billing;
